"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreetType = void 0;
var StreetType;
(function (StreetType) {
    StreetType[StreetType["Abbey"] = 1] = "Abbey";
    StreetType[StreetType["Acrea"] = 2] = "Acrea";
    StreetType[StreetType["Allee"] = 3] = "Allee";
    StreetType[StreetType["Aut"] = 4] = "Aut";
    StreetType[StreetType["Av"] = 5] = "Av";
    StreetType[StreetType["Ave"] = 6] = "Ave";
    StreetType[StreetType["Bay"] = 7] = "Bay";
    StreetType[StreetType["Beach"] = 8] = "Beach";
    StreetType[StreetType["Bend"] = 9] = "Bend";
    StreetType[StreetType["Blvd"] = 10] = "Blvd";
    StreetType[StreetType["Boul"] = 11] = "Boul";
    StreetType[StreetType["Bypass"] = 12] = "Bypass";
    StreetType[StreetType["Byway"] = 13] = "Byway";
    StreetType[StreetType["C"] = 14] = "C";
    StreetType[StreetType["Campus"] = 15] = "Campus";
    StreetType[StreetType["Cape"] = 16] = "Cape";
    StreetType[StreetType["Car"] = 17] = "Car";
    StreetType[StreetType["Carref"] = 18] = "Carref";
    StreetType[StreetType["CDs"] = 19] = "CDs";
    StreetType[StreetType["Cercle"] = 20] = "Cercle";
    StreetType[StreetType["CH"] = 21] = "CH";
    StreetType[StreetType["Chase"] = 22] = "Chase";
    StreetType[StreetType["Cir"] = 23] = "Cir";
    StreetType[StreetType["Circt"] = 24] = "Circt";
    StreetType[StreetType["Close"] = 25] = "Close";
    StreetType[StreetType["Common"] = 26] = "Common";
    StreetType[StreetType["Conc"] = 27] = "Conc";
    StreetType[StreetType["Cote"] = 28] = "Cote";
    StreetType[StreetType["Cour"] = 29] = "Cour";
    StreetType[StreetType["Cove"] = 30] = "Cove";
    StreetType[StreetType["Cres"] = 31] = "Cres";
    StreetType[StreetType["Crnrs"] = 32] = "Crnrs";
    StreetType[StreetType["Crois"] = 33] = "Crois";
    StreetType[StreetType["Cross"] = 34] = "Cross";
    StreetType[StreetType["Crt"] = 35] = "Crt";
    StreetType[StreetType["Ctr"] = 36] = "Ctr";
    StreetType[StreetType["Dale"] = 37] = "Dale";
    StreetType[StreetType["Dell"] = 38] = "Dell";
    StreetType[StreetType["Divers"] = 39] = "Divers";
    StreetType[StreetType["Downs"] = 40] = "Downs";
    StreetType[StreetType["Dr"] = 41] = "Dr";
    StreetType[StreetType["Ech"] = 42] = "Ech";
    StreetType[StreetType["End"] = 43] = "End";
    StreetType[StreetType["Espl"] = 44] = "Espl";
    StreetType[StreetType["Estate"] = 45] = "Estate";
    StreetType[StreetType["Expy"] = 46] = "Expy";
    StreetType[StreetType["Exten"] = 47] = "Exten";
    StreetType[StreetType["Farm"] = 48] = "Farm";
    StreetType[StreetType["Field"] = 49] = "Field";
    StreetType[StreetType["Forest"] = 50] = "Forest";
    StreetType[StreetType["Front"] = 51] = "Front";
    StreetType[StreetType["Fwy"] = 52] = "Fwy";
    StreetType[StreetType["Gate"] = 53] = "Gate";
    StreetType[StreetType["Gdns"] = 54] = "Gdns";
    StreetType[StreetType["Glade"] = 55] = "Glade";
    StreetType[StreetType["Glen"] = 56] = "Glen";
    StreetType[StreetType["Green"] = 57] = "Green";
    StreetType[StreetType["Grnds"] = 58] = "Grnds";
    StreetType[StreetType["Grove"] = 59] = "Grove";
    StreetType[StreetType["Harbr"] = 60] = "Harbr";
    StreetType[StreetType["Hghlds"] = 61] = "Hghlds";
    StreetType[StreetType["Hill"] = 62] = "Hill";
    StreetType[StreetType["Hollow"] = 63] = "Hollow";
    StreetType[StreetType["Hts"] = 64] = "Hts";
    StreetType[StreetType["Hwy"] = 65] = "Hwy";
    StreetType[StreetType["Ile"] = 66] = "Ile";
    StreetType[StreetType["Imp"] = 67] = "Imp";
    StreetType[StreetType["Island"] = 68] = "Island";
    StreetType[StreetType["Key"] = 69] = "Key";
    StreetType[StreetType["Knoll"] = 70] = "Knoll";
    StreetType[StreetType["Landing"] = 71] = "Landing";
    StreetType[StreetType["Lane"] = 72] = "Lane";
    StreetType[StreetType["Line"] = 73] = "Line";
    StreetType[StreetType["Link"] = 74] = "Link";
    StreetType[StreetType["Lkout"] = 75] = "Lkout";
    StreetType[StreetType["Lmts"] = 76] = "Lmts";
    StreetType[StreetType["Loop"] = 77] = "Loop";
    StreetType[StreetType["Mall"] = 78] = "Mall";
    StreetType[StreetType["Manor"] = 79] = "Manor";
    StreetType[StreetType["Maze"] = 80] = "Maze";
    StreetType[StreetType["Meadow"] = 81] = "Meadow";
    StreetType[StreetType["Mews"] = 82] = "Mews";
    StreetType[StreetType["Montee"] = 83] = "Montee";
    StreetType[StreetType["Moor"] = 84] = "Moor";
    StreetType[StreetType["Mount"] = 85] = "Mount";
    StreetType[StreetType["Mtn"] = 86] = "Mtn";
    StreetType[StreetType["Orch"] = 87] = "Orch";
    StreetType[StreetType["Parade"] = 88] = "Parade";
    StreetType[StreetType["Parc"] = 89] = "Parc";
    StreetType[StreetType["Pass"] = 90] = "Pass";
    StreetType[StreetType["Path"] = 91] = "Path";
    StreetType[StreetType["Pines"] = 92] = "Pines";
    StreetType[StreetType["Pk"] = 93] = "Pk";
    StreetType[StreetType["Pky"] = 94] = "Pky";
    StreetType[StreetType["Pl"] = 95] = "Pl";
    StreetType[StreetType["Place"] = 96] = "Place";
    StreetType[StreetType["Plat"] = 97] = "Plat";
    StreetType[StreetType["Plaza"] = 98] = "Plaza";
    StreetType[StreetType["Port"] = 99] = "Port";
    StreetType[StreetType["Prom"] = 100] = "Prom";
    StreetType[StreetType["Pt"] = 101] = "Pt";
    StreetType[StreetType["Ptway"] = 102] = "Ptway";
    StreetType[StreetType["Pvt"] = 103] = "Pvt";
    StreetType[StreetType["Quai"] = 104] = "Quai";
    StreetType[StreetType["Quay"] = 105] = "Quay";
    StreetType[StreetType["Rang"] = 106] = "Rang";
    StreetType[StreetType["Rd"] = 107] = "Rd";
    StreetType[StreetType["Rdpt"] = 108] = "Rdpt";
    StreetType[StreetType["Rg"] = 109] = "Rg";
    StreetType[StreetType["Ridge"] = 110] = "Ridge";
    StreetType[StreetType["Rise"] = 111] = "Rise";
    StreetType[StreetType["Rle"] = 112] = "Rle";
    StreetType[StreetType["Row"] = 113] = "Row";
    StreetType[StreetType["Rte"] = 114] = "Rte";
    StreetType[StreetType["Rue"] = 115] = "Rue";
    StreetType[StreetType["Run"] = 116] = "Run";
    StreetType[StreetType["Sent"] = 117] = "Sent";
    StreetType[StreetType["Sq"] = 118] = "Sq";
    StreetType[StreetType["St"] = 119] = "St";
    StreetType[StreetType["Subdiv"] = 120] = "Subdiv";
    StreetType[StreetType["Ter"] = 121] = "Ter";
    StreetType[StreetType["Thick"] = 122] = "Thick";
    StreetType[StreetType["Tline"] = 123] = "Tline";
    StreetType[StreetType["Towers"] = 124] = "Towers";
    StreetType[StreetType["Trail"] = 125] = "Trail";
    StreetType[StreetType["Trnabt"] = 126] = "Trnabt";
    StreetType[StreetType["Tsse"] = 127] = "Tsse";
    StreetType[StreetType["Vale"] = 128] = "Vale";
    StreetType[StreetType["Via"] = 129] = "Via";
    StreetType[StreetType["View"] = 130] = "View";
    StreetType[StreetType["Villge"] = 131] = "Villge";
    StreetType[StreetType["Vista"] = 132] = "Vista";
    StreetType[StreetType["Voie"] = 133] = "Voie";
    StreetType[StreetType["Walk"] = 134] = "Walk";
    StreetType[StreetType["Way"] = 135] = "Way";
    StreetType[StreetType["Wharf"] = 136] = "Wharf";
    StreetType[StreetType["Wood"] = 137] = "Wood";
    StreetType[StreetType["Wynd"] = 138] = "Wynd";
})(StreetType = exports.StreetType || (exports.StreetType = {}));
